import type { ButtonHTMLAttributes } from "react";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & { variant?: "primary" | "secondary" | "quiet" };
export function Button({ variant = "primary", className = "", ...props }: Props) {
  return <button className={`button button-${variant} ${className}`.trim()} {...props} />;
}
